<template>
    <body >
        <div id="__next">
            <div>
                <div>
    
                    <div class="w-100" style="height: 60px"></div>
    
                    <Header />
    
                </div>
    
                <div class="container">
    
                    <main class="grid-main-standard">
                        <div class="grid-full-inner-standard">
                            <div class="dn show-for-print">
                                <div class="flex flex-column items-center"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 697.01 104.61" width="200" height="30">
    
                                                        <title>Janathavani</title>
    
                                                        <path d="M39.2 32v36.6c4.7-2.8 7-6.8 8.7-12.1l1.2.6c-1.1 13.2-10.3 26-24.3 26S0 72.6 0 55.8C0 43 7.7 35.1 18.7 28.2a16.11 16.11 0 00-4.4-.6c-7.2 0-11.4 4.9-11.4 9.9H1.5a14.77 14.77 0 01-.1-2.1c0-9.3 5.5-19.7 16.9-19.7 7.3 0 12.9 6.7 21.4 6.7 4.3 0 6.7-1.6 8.4-5.3h1.2c-.1 6.5-2 12.8-10.1 14.9zm-19-3.3C15.1 34 10.1 39.6 10.1 50.9c0 6.2 1.9 12.4 6.6 16.4l3.1-1.7V40.3L16.6 42l-1-1.6 15-8.4c-3.8-.8-6.9-2.3-10.4-3.3zm17.1 3.7a17 17 0 01-2.3.1 17.52 17.52 0 01-4-.4v29.5l-12.8 7a15.57 15.57 0 009.9 3 22.58 22.58 0 009.2-2zm44 9.2v34.3c0 9.6-8.51 16.11-18 18l-.6-1c4.7-2.3 7.8-6.41 7.8-11.41V45.7l-4.9-4.5-2.6 2.6v27.1l3 2.8v.4l-8.1 8.61-9.3-8.51v-.4l3.6-3.8V25.8l10.6-11.3.2.1v26.6l8.7-9.2 8.7 7.9 2.7-2.6 1.31 1.3zM97.91 62v4.5l9 7.1 7-7.3 1.3 1.3L101 82.8 88.21 72.6l-2.8 2.8-1.2-1.3 3.1-3.2V45.8l18.9-13.8 10.5 16.3zm.2-22.6l-.2.1v20.1l8.7-6.4zM180 82.71l-13.9-12-10.6 12-14.4-12.41V50.7h-2.8a3.89 3.89 0 00-4.1 3.5h-1a15.87 15.87 0 01-.5-3.8c0-2.6 1.1-9.4 8.4-9.4V25.8c0-5.9-3.9-6.2-3.9-11.3 0-5.7 5.4-11 15.3-14.5l.9.8c-3.3 1.6-6 3.6-6 7.9 0 6.6 6.4 4.9 6.4 15.3v4l11.7-12.3 12.3 12.1 11.6-12.1 11.2 11v37zM165.4 32.8l-7-6.9-4.6 4.7v34.3l8.5 7.3 3.1-3.5zm22.6-1.3l-5.6-5.6-4.3 4.3v34.6l9.8 8.6.1-.1zm44.8 51.21l-9.4-8.61h-.2l-8.3 8.61-10.1-8.91-2.3 2.3-1.3-1.3 2.9-3V45.5l19-13.6 10.4 8.2 2.8-2.8 1.5 1.3-3.6 3.4v27.1l4.6 4.2 2.9-3 1.5 1.4zm-9.4-37.41l-8.3-6.5-.2.2v29.2l6.1 5.4 2.4-2.3zm40.6 4.8h9.4v21.4l-15.9 11.21a11.52 11.52 0 00-8.8-4.11c-3 0-5.4 1.4-7.8 4l-1.4-.5 13.8-19.8h-8.5V43.7L261.4 32c2 1.6 3.6 2.6 6.2 2.6a11.35 11.35 0 007.1-2.2l1 .7zm-1.4 8.8h-4.7l-11.1 15.9.1.2a12.36 12.36 0 017.6-2.5 10.4 10.4 0 018 3.8l.1-.09zm6.4-19.6a9.73 9.73 0 01-6.9 2.3 8.92 8.92 0 01-6.3-2.9l-.2.1v14.6h3.8l9.7-14zm40 2.3v34.3c0 9.6-8.51 16.11-18 18l-.6-1c4.7-2.3 7.8-6.41 7.8-11.41V45.7l-4.9-4.5-2.6 2.6v27.1l3 2.8v.4l-8.1 8.61-9.3-8.51v-.4l3.6-3.8V25.8l10.6-11.3.2.1v26.6l8.7-9.2 8.71 7.9 2.7-2.6 1.3 1.3zm19.6 41.11l-8.3-7.61-2.8 2.8-1.3-1.3 3.3-3.4V44.7l-3.6-3.3-2.7 2.6-1.3-1.3L322 32l7.6 6.9 2.7-2.8 1.4 1.4-3.4 3.4v28.6l4.2 3.9 3-3.1 1.3 1.4zm-2.9-51.61l-8.2-7.5 7.5-8 8.2 7.5zm46.1 51.61l-8.7-7.91V45.6l-4.7-4.4-3.4 3.5v26.1l3.1 2.9v.4l-8.2 8.61-9.3-8.51v-.3l3.6-3.8V44.9l-4.1-3.7-3 3-1.4-1.3L345.9 32l9.1 8.1v2l9.5-10.1 8.7 7.8 2.9-2.9 1.3 1.4-3.5 3.5v28l3.9 3.7 3.3-3.4 1.2 1.3zm43-41V75.6c0 5.2 2.9 5 2.9 8.9 0 4.51-6.5 8.71-16.5 16.21-3.3-3.6-5.6-5.1-8.7-5.1a19.85 19.85 0 00-10.7 3.6l-1-.8 13.7-16.11-9-7.09-2.9 2.89-1.3-1.3 3.4-3.5V45.5l19-13.6 10.2 8 3-2.9 1.3 1.3zm-7.7 41.71c-2.5-1.61-3.1-3.31-3.1-7.61V74.3L387.9 93l.1.1c3.2-1.9 5.6-3.1 10.3-3.1 4 0 6.9 1.7 9.5 4 1.9-1.6 3.3-3.2 3.3-5.7 0-1.99-1.5-3.3-4-4.89zM404 45.3l-8.3-6.5-.2.2v30.7l5.9 4.6 2.6-3zm31.5 37.41l-8.8-6.91-2.7 2.7-1.3-1.29 3.1-3.21V39.4H420l-.2-.2 3.5-5.2h2.5v-6.7L436.4 16l.2.2V34h8l.2.2-3.5 5.2h-4.7v30.3l4.8 3.7 3.3-3.4 1.3 1.4zm43.71-40.11v27.7l-16.9 12.5L450 73.5l-2.8 2.8-1.3-1.3 3.2-3.3v-27L466.81 32l11.4 8.9 2.9-2.9 1.3 1.4zm-10.8 3L460 39l-.09.1v29.8l8.5 6.4zm50.4 37l-8.7-7.9V45.5l-4.7-4.4-3.41 3.5v26.1l3.1 2.9v.4l-8.2 8.61-9.3-8.51v-.3l3.6-3.8V44.8l-4.1-3.7-3 3-1.4-1.3 10.2-10.9L502 40v2l9.5-10.1 8.7 7.8 2.9-2.9 1.3 1.4-3.5 3.5v28l3.9 3.7 3.3-3.4 1.2 1.3zm61.39.11a12.91 12.91 0 00-6.3-4.61v20.81l-.2.1-5.5-5.1-11.6 10.7-.2-.1V77.6a18.83 18.83 0 00-10.2 6.61l-.8-.5c.7-7.71 4.5-13.41 11-15.61V48.6h-2.1a5.25 5.25 0 00-5.3 4.2h-1.2a12.28 12.28 0 01-.7-4.6c0-4.9 3.3-8.6 8.7-8.6h.6V28.8l-3.6-3.2-2.8 2.8-1.4-1.3 11.1-11.4 9.4 8.6v9.8L572 31V19.5h1.9V29l12.5-13.3L597.7 26v43.5zM572 32.9l-2.9 3v56.31l2.9 2.7zm13.1-2.3l-5.9-5.4-5.3 5.6v36.3c4.7.6 8.2 2.2 11.1 5.3l.1-.1zm48.7 12v27.7l-16.9 12.5-12.3-9.3-2.8 2.8-1.3-1.3 3.2-3.3v-27L621.4 32l11.4 8.9 2.9-2.9 1.3 1.4zm-10.8 3l-8.4-6.6-.1.1v29.8l8.5 6.4zm35.6 4.5h9.4v21.4l-15.9 11.21a11.52 11.52 0 00-8.8-4.11c-3 0-5.4 1.4-7.8 4l-1.4-.5 13.8-19.8h-8.5V43.7L656 32c2 1.6 3.6 2.6 6.2 2.6a11.38 11.38 0 007.11-2.2l1 .7zm-1.4 8.8h-4.7l-11.1 15.9.1.2a12.36 12.36 0 017.6-2.5 10.4 10.4 0 018 3.8l.1-.09zm6.41-19.6a9.78 9.78 0 01-6.91 2.3 8.92 8.92 0 01-6.3-2.9l-.2.1v14.6h3.8l9.7-14zm22.9 43.41l-8.8-6.91-2.71 2.7-1.3-1.29 3.1-3.21V39.4H671l-.2-.2 3.5-5.2h2.5v-6.7L687.41 16l.2.2V34h8l.2.2-3.5 5.2h-4.7v30.3l4.8 3.7 3.3-3.4 1.3 1.4z"></path>
    
                                                    </svg><span class="italic gray font-xxxxs font--body"></span></div>
    
                            </div>
    
                            <header class="w-100" data-qa="main-full" v-if="showNews">
                                <div class="mt-lg"></div>
    
                                <div class="w-100" style="max-width:1000px">
        
                                    <h1 class="font--headline offblack headline mb-sm detail-heading unset-m" data-qa="headline" id="main-content">
    
                                        <span data-qa="headline-opinion-text" v-html="detail.name">
    
                                                        </span></h1>
    
                                </div>
    
                                <div class="flex print-byline print-mt-none">
    
                                    <div class="byline-wrapper flex-column flex">
    
                                        <div class="mb-sm flex" style="max-width:500px"><span>    
    
                                                                <div class="dib items-center" data-qa="author-byline"><span class="">
        
                                                                        <div class="dib font-xxs" data-qa="name-with-optional-link" data-cy="name-with-optional-link"><span class="gray-darkest" data-qa="attribution-text">By
    
                                                                            </span>
    
                                            <router-link :to="{name:'Author',params:{id:detail.label}}"> <span data-qa="author-name" class="gray-darkest decoration-none" rel="author"> {{detail.author}} </span></router-link>
    
                                        </div>
    
                                        </span>
    
                                    </div>
    
                                    </span>
    
                                </div>
    
                                <div class="mb-md mb-lg-ns font--subhead font-xxxs unset-m-b gray-dark" data-qa="timestamp">
                                    <span data-qa="display-date" class="gray-dark display-date">{{detail.postdate}}</span></div>
    
                        </div>
    
                </div>
    
                </header>
    
            </div>

            <div class="row" v-if="showNews">
    
                <article class="grid-article mb-xxl-ns col-sm-8" data-qa="main">
    
                    <div data-qa="lede-art" class="">
        
                        <figure class="overflow-hidden relative hide-for-print center center mb-sm mb-md-ns ml-auto-ns mr-auto-ns">
    
                            <div style="filter: blur(0px); transition: filter 0.1s ease 0s; line-height: 0;" class="w-100-1 mw-100 h-auto" width="600" height="399">
                                
                                <carousel :autoplay="true" :nav="false" :indicators="false" :items="1" v-if="detail.image_collection" :responsive="{
    
                                                0: { items: 1 },
    
                                                576: { items: 1 },
    
                                                600: { items: 1 },
    
                                                768: { items: 1 },
    
                                                1200: { items: 1 },
    
                                                1500: { items: 1 },
    
                                                }">
    
                                    <img :src="$root.URL_ROOT+'uploads/Product/'+detail.front_image" style="background-size:cover;max-width:1600px;" alt="" class="w-100-1 mw-100 h-auto" width="600" height="399" sizes="(max-width: 440px) 440px,(max-width: 600px) 691px,(max-width: 768px) 691px,(min-width: 769px) and (max-width: 1023px) 960px,(min-width: 1024px) and (max-width: 1299px) 530px,(min-width: 1300px) and (max-width: 1439px) 691px,(min-width: 1440px) 916px,440px"
    
                                        decoding="async">
                                        
    
                                    <template v-for="(allimg,key) in getImg(detail.image_collection)">
    
                                            <img :src="$root.URL_ROOT+'uploads/Product/'+allimg" :key="key" v-if="allimg" style="background-size:cover;max-width:1600px;" alt="" class="w-100-1 mw-100 h-auto" width="600" height="399" sizes="(max-width: 440px) 440px,(max-width: 600px) 691px,(max-width: 768px) 691px,(min-width: 769px) and (max-width: 1023px) 960px,(min-width: 1024px) and (max-width: 1299px) 530px,(min-width: 1300px) and (max-width: 1439px) 691px,(min-width: 1440px) 916px,440px" decoding="async">
                                    </template>
                                </carousel>
                                        
                                            <img :src="$root.URL_ROOT+'uploads/Product/'+detail.front_image"  v-else  :style="'width:200px;background-size:cover;max-width:1600px;background-image:url('+$root.URL_ROOT+'uploads/Product/'+detail.front_image+')'" alt="" class="w-100-1 mw-100 h-auto" width="600" height="399" sizes="(max-width: 440px) 440px,(max-width: 600px) 691px,(max-width: 768px) 691px,(min-width: 769px) and (max-width: 1023px) 960px,(min-width: 1024px) and (max-width: 1299px) 530px,(min-width: 1300px) and (max-width: 1439px) 691px,(min-width: 1440px) 916px,440px" decoding="async">
                                        </div>
                                        <figcaption class="ml-gutter mr-gutter mr-auto-ns ml-auto-ns font--subhead font-xxxs mt-xs  left gray-dark">{{detail.img_label}}</figcaption>
                                    </figure>
                                </div>
                                <div class="grid-body p-l-r-10 m-t-25m">
                                    <div class="hide-for-print mr-0 -mr-lg-ns  mt-0 relative undefined" style="margin-left:-12px;margin-top:-9px;min-height:40px" data-qa="article-actions">
                                        <div class="PJLV PJLV-iAjpuP-css flex items-center pr-sm">
                                            <div class="social-share sharing-btn my-3">
                                                <p style="color:#000;" class="post-content"> <img src="../assets/images/comment.png" width="25" style="margin-right:5px;" /> Comment</p>
                                            </div>
                                            <div class="social-share sharing-btn my-3" v-if="detail.gift_status>0">
                                                <p style="color:#000;" class="post-content"> <img src="../assets/images/gift.png" width="25" style="margin-right:5px;" /> Gift Article </p>
    
                                            </div>
                                            <div class="social-share sharing-btn my-3">
                                                <p style="color:#000;" class="post-content" @click="isShowing ^= true">
                                                     <img src="../assets/images/share.png" width="25" style="margin-right:5px;" /> Share  </p>
                                                <div class="share-me" v-show="isShowing">
                                                    <facebook :url="url" scale="2"></facebook>
                                                    <twitter :url="url" title="Check me on Github" scale="2"></twitter>
                                                    <linkedin :url="url" scale="2"></linkedin>
                                                    <WhatsApp :url="url" scale="2"></WhatsApp>
                                                    <email :url="url" subject="Hello" scale="2"></email>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="teaser-content grid-center">
                                        <div class="article-body" data-qa="article-body">
                                            <!----v-html="detail.description"-->
                                            <p data-qa="drop-cap-letter" data-el="text" v-html="detail.description" class="txt-justy font-copy font--article-body gray-darkest ma-0 pb-md sub-heading" ></p>
                                        </div>
                                        
                                    </div>

                                    <div class="video-section" v-if="detail.video">
                                        <div>
                                            <vue-core-video-player  :src="$root.URL_ROOT+'uploads/video/'+detail.video"></vue-core-video-player>
                                        </div>
                                    </div>

                                    <div class="container">
                                        <div class="row">
                                            <!-- <DontMissDetail v-if="catName[2].id==3" :DontMiss="getFoodData" :label="catName[2].name"></DontMissDetail>
                                            <DontMissDetail v-if="catName[3].id==4" :DontMiss="getTravelData" :label="catName[3].name"></DontMissDetail> -->


                                            <template>
                                                <div class="hpgrid-max-width ma-auto" data-chain-name="DM module" data-gtm-module="DM module" style="position: relative">
                                                    <div class="mr-sm ml-sm mr-0-ns ml-0-ns">
                                                        <div class="gray-darkest mb-sm label label-section-large left" v-on:click="relatedShow = !relatedShow">
                                                            <span class="font-xs font-bold uppercase letter-spacing offblack"><span class="font-times"> Related News </span>
                                                        
                                                            <transition name="fade">
                                                                <img
                                                                  src="../assets/images/icon/up.png"
                                                                  class="icon-click"
                                                                  v-if="relatedShow"
                                                                />
                                                                <img
                                                                  src="../assets/images/icon/down.png"
                                                                  class="icon-click"
                                                                  v-else
                                                                />
                                                              </transition>
                                                
                                                        </span>
                                                        </div>
                                                    </div>
                                                    <transition name="fade">
                                                        <div class="" v-if="relatedShow">
                                                            <div class="row" v-if="relatedNews.length">
                                                                <template v-for="(News,ind) in relatedNews.slice(0,8)">
                                                                    <div :key="News.id" v-if="ind<6" class=" col-sm-4 card" >
                                                                        <div class="left no-wrap-text art-size--fullWidth">
                                                                            <div class="card-top card-text">
                                                                                <div class="w-100 mw-100 overflow-hidden relative lh-0 mb-xs">
                                                                                    <div class="dib" style="width: 100%;height: 237px;background-color: #eee;">
                                                                                        <a :to="{name:'Detail',params:{id:News.id}}" class="art-link">
                                                                                            <img style="width: 100%;height: 237px;background-color: #eee;" :src="$root.URL_ROOT+'uploads/Product/'+News.front_image" /></a>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="headline relative gray-darkest pb-xs">
                                                                                    <h2 class="
                                                                                    left-news-hrading font-size-sm font-bold
                                                                            left
                                                                            relative
                                                                            ">
                                                                                        <router-link :to="{name:'Detail',params:{id:News.id}}">
                                                                                            <span class="break-word" v-html="News.name.slice(0, News.namecount)"> </span></router-link>
                                                                                    </h2>
                                                                                </div>
                                                                                <div class="byline gray-dark font-xxxxs pb-xs">
                                                                                    <router-link :to="{name : 'Author',params:{id:News.label}}"> {{News.author}} </router-link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div v-else style="height:70px;" ></div>
                                                        </div>
                                                        
                                                    </transition>
                                                </div>
                                                </template>


                                        </div>
                                    </div>
                                    <div class="">
                                        <div id="comment_app" class="" >
                                            <div class="navbar navbar-default" >
                                                <div class="navbar-header chat-header" >
                                                    <a class="navbar-brand">Comments</a>
                                                </div>
                                                <div class="navbar-collapse collapse" >
                                                    <ul class="navbar-right navbar-nav nav" >
                                                        <li>
                                                            <a href="#">{{total_comments}} Comments</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        <div>
                                        <div class="row" >
                                            <!-- form -->
                                            <form class="col-sm-12" v-on:submit.prevent='submit'>
                                                <h3 class="comment-h3">Write Comments</h3>
                                                <div class="form-group">
                                                    <textarea required="required" v-if="uid>0" placeholder="Your comment" v-model='input' class="form-control" ></textarea>
                                                        <template @click="showError()" v-else>
                                                            <textarea required="required" class="form-control" disabled v-model='input' placeholder="Your comment"></textarea>
                                                        </template>
                                                
                                                </div>
                                                <button class="btn btn-primaries mt10" >Post</button>
                                                <br />
                                                <br />
                                                <legend></legend>
                                            </form>
                                            <!-- form -->
                                            <div class="cols-m-12" >
                                                <div class="col-sm-12" >
                                                    <div v-if='total_comments == 0' >
                                                        <div class="alert alert-info" >
                                                            No Comments
                                                        </div>
                                                    </div>
                                                    <div class="list-group" >
                                                        <div class="list-group-item" v-for="comment,index in comments" v-if="checkComment" >
                                                            <p> <i class="fa fa-user user-icon" style="font-size: 28px;"></i><strong>&nbsp; {{comment.username}}</strong> </p>
                                                            <p style="padding: 10px 10px 10px 24px;">&nbsp;&nbsp; {{comment.comment}}</p>
                                                            <div class=""></div>
                                                        <div class="like-reply">
                                                            <!-- <p class="com-likes">
                                                                <i v-on:click='like(index)' class="fa fa-thumbs-up"></i>
                                                                {{comment.total_likes}}
                                                            </p> 
                                                            <p>
                                                                <i class="fa fa-reply" aria-hidden="true"></i>
                                                            </p>-->
                                                        </div>
                                                            <h5>Replies</h5>
                                                            <div class="list-group" >
                                                                <div class="list-group-item" v-for='reply,index in comment.replies' >
                                                                    <p>
                                                                        <strong>{{reply.username}}:</strong> <br/><p>&nbsp;&nbsp;{{reply.reply}}</p>
                                                                    </p>
                                                                </div>
                                                                <div class="list-group-item"  style="padding: 00;" >
                                                                    <form v-on:submit.prevent='addReply(index,comment.cid)' >
                                                                        <input type="hidden"  :value="comment.cid" >
                                                                        <input v-model='reply' placeholder="reply" class="form-control" />
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                            <div class="grid-rail col-sm-4">
                                <aside class="flex flex-column hide-for-print h-100" data-qa="right-rail">
                                    <div class="pb-lg-mod" data-qa="right-rail-item">
                                        <div style="min-height:1050px;top:65px" class="dn db-ns" data-qa="right-rail-ad">
                                            <div class="sticky" style="top: 65px;">
                                                <div aria-hidden="true" class="hide-for-print relative flex justify-center content-box items-center b bh" style="border-top-color: transparent; border-bottom-color: transparent;">
                                                    <div class="center absolute w-100 border-box">
                                                        <div class="dib gray-dark pl-xs pr-xs font-sans-serif light font-xxxxs lh-md"></div>
                                                    </div>
                                                    <div data-testid="placeholder-box " class="w-100 h-100 absolute flex flex-column justify-center border-box bg-offwhite" style="width: 300px; height: 600px;">
                                                        <div class="flex flex-column justify-center font-sans-serif center font-xxs light gray-dark lh-md">
                                                            <!-- <div>Advertisement</div> -->
                                                            <template v-for="adata in adData">
                                                                <a v-if="adata.side=='right'" :href="adata.url">
                                                                    <img :src="$root.URL_IMAGES+'Content/'+adata.image" style="width:100%;"  />
                                                                </a>    
                                                            </template>
                                                            

                                                        </div>
                                                    </div>
                                                    <!------->
                                                    <div class="relative flex flex-column justify-center w-100" style="min-height: 600px; min-width: 300px;">
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                   
                                </aside>
                            </div>
                        </div>
                    </main>
                </div>
                <Footer />
            </div>
        </div>
    </body>
    </template>
    
<script>
import axios from "axios";
import Header from "@/components/Header";
import Footer from "@/components/footer";
import Guide from '../components/Guide.vue';
import DontMissDetail from '../components/DontMissDetail.vue';
import DontMiss from '../components/DontMiss.vue';
import carousel from "vue-owl-carousel";
import Design2 from '../components/Design2.vue';
import Vue from 'vue'

import VueCoreVideoPlayer from 'vue-core-video-player'

Vue.use(VueCoreVideoPlayer)

import {
    Facebook,
    Twitter,
    Linkedin,
    Pinterest,
    Reddit,
    Telegram,
    WhatsApp,
    Email,
    Google,
} from "vue-socialmedia-share";

export default {
    components: {
        Header,
        Footer,
        DontMiss,
        Design2,
        Guide,
        Facebook,
        Twitter,
        Linkedin,
        Pinterest,
        Reddit,
        Telegram,
        WhatsApp,
        Email,
        Google,
        carousel,
        DontMissDetail,
        

    },
    data() {
        return {
            input: "",
            reply: "",
            total_comments: 0,
            comments: [],
            ratingDisable: false,
            isShowing: false,
            userRating: [],
            isShow: 1,
            detail: [],
            ratingProduct: 0,
            uid: localStorage.getItem("user"),
            product_id: this.$route.params.id,
            qty: 1,
            mainImage: "",
            allimages: "",
            OfferProduct: [],
            latestData: [],
            DontMiss: [],
            travelNews: [],
            foodNews: [],
            checkLogin: false,
            showpass: false,
            nowShow: false,
            catName: [],
            getFoodData: [],
            getTravelData: [],
            url: '',
            orderDetailData: [],
            fields: {
                username: '',
                password: '',
                type: "userlogin",
            },
            userDetailsData: [],
            checkComment: false,
            showNews: false,
            adData:[],
            relatedShow:false,
            relatedNews:[],
        };
    },
    mounted() {
        this.getUserDetails();
        this.productDetail();
        this.goToTop();
        this.guidData();
        this.moreNews();
        this.dontData();
        this.travelData();
        this.foodData();
        this.categoryName();
        this.getCommentsData();
        this.getAdData();
        this.url = window.location.href
        if (this.uid) {
            this.orderDetail()
        } else {
            // var x = window.scrollX;
            // var y = window.scrollY;
            // window.onscroll = function () {
            //     window.scrollTo(x, y);
            // };
        }
    },

    watch: {

        "$route.params.id": function(oldVal, newVal) {
            this.detail=[];
            this.productDetail();
            console.log('asdadad dsad asdad ads');
            if (oldVal != newVal) {
                
            }
        },
        nowShow: function(newVal) {
            this.nowShow = newVal
        },
        uid: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.uid = localStorage.getItem("user")
            }
        },
        detail: function(newVal) {
            this.showNews=false;
            this.detail = newVal;
            // console.log('ddadasdasdada');
            // console.log(newVal);
            //this.showNews=true;

        },
        comments: function(val) {
            this.comments = val;
        },
        
    },
    methods: {
        getFormate(dt){
            var setD=new Date(dt);
            console.log(setD)
            var day=setD.getDay();
            var month=setD.getMonth();
            var year=setD.getFullYear();
            console.log(day+'-'+month+'-'+year)
        },
        getAdData(){
            var ev=this;
            
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getAdsData',
                    
                }
            }).then(function(response) {
                var data = response.data;
                ev.adData = data.data;
                //console.log(data)
            })
        },
        getUserDetails() {
            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getUserDetails',
                    uid: ev.uid,
                }
            }).then(function(response) {
                var data = response.data;
                ev.userDetailsData = data;
                //console.log(data)
            })
        },
        showError() {
            this.$toasted.global.error({ message: 'Please Sign in ', });
            //console.log('sadadadad');
        },
        getReplySingleton: function(reply, username) {
            return function() {
                return {
                    reply,
                    username,
                };
            }
        },
        getSingleTon: function(comment, username, cid) {
            return function() {
                return {
                    cid,
                    username,
                    comment,
                    total_likes: 0,
                    replies: []
                }
            }
        },
        getCommentsData() {
            var ev = this;
            ev.comments = [];
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getComment',
                    newsid: this.$route.params.id,
                }
            }).then(function(response) {
                var data = response.data.data
                // console.log(response.data)
                var ind = 0;
                data.forEach((value, key) => {
                    var comment = ev.getSingleTon(value.comment, value.comment_sender_name, value.comment_id);
                    var old = ev.comments;
                    var newc = [...old, comment()];
                    ev.comments = newc;
                    value.reply.forEach((val2, key2) => {
                        var s = ev.getReplySingleton(val2.comment, val2.comment_sender_name);

                        var replies = ev.comments[ind].replies;
                        var n = [...replies, s()];
                        ev.comments[ind].replies = n;
                    })
                    ind++;
                })
                setTimeout(() => {
                    ev.checkComment = true;
                }, 2000);
                console.log(ev.comments)

            })

        },
        submit() {
            var ev = this;
            if (this.uid > 0) {
                // var comment = this.getSingleTon(this.input,this.userDetailsData.username);
                // var old = this.comments;
                // var newc = [...old, comment()];
                // this.comments = newc;

                // this.total_comments = this.comments.length;

                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: {
                        type: 'saveComment',
                        uid: ev.uid,
                        newsid: this.$route.params.id,
                        comment: ev.input,

                    }
                }).then(function(response) {
                    var data = response.data.data
                    //ev.orderDetailData = data
                    if(data.status=='success'){
                        ev.$toasted.global.success({
                            message: data.msg
                        });
                        ev.getCommentsData();
                    }else{
                        ev.$toasted.global.error({
                            message: data.msg,
                        });
                    }
                })
            } else {
                this.$toasted.global.error({
                    message: "Please Sign in ",
                });
            }
            this.input = "";

        },
        like(index) {
            this.comments[index].total_likes = this.comments[index].total_likes + 1;
        },
        addReply(index, cid) {
            var ev = this;
            if (this.uid > 0) {
                // var s = this.getReplySingleton(this.reply);
                // var replies = this.comments[index].replies;
                // var n = [...replies, s()];
                // this.comments[index].replies = n;

                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: {
                        type: 'saveReply',
                        uid: ev.uid,
                        newsid: this.$route.params.id,
                        comment: ev.reply,
                        cid: cid,
                    }
                }).then(function(response) {
                    var data = response.data
                    
                    if(data.status=='success'){
                        ev.$toasted.global.success({
                            message: data.msg
                        });
                        ev.getCommentsData();
                    }else{
                        ev.$toasted.global.error({
                            message: data.msg,
                        });
                    }
                })


            } else {
                this.$toasted.global.error({
                    message: "Please Sign in ",
                });
            }
            this.reply = "";
        },
        categoryName() {
            const axios = require("axios");
            var self = this;
            axios.post(this.$root.URL_ROOT + "api.php", {
                    type: "getcategoryName",
                })
                .then(function(response) {
                    var data = response.data;
                    self.catName = data.data;
                });
        },
        getImg(imgAry) {
            return JSON.parse(imgAry)
        },
        orderDetail() {

            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'myorder',
                    uid: ev.uid,

                }
            }).then(function(response) {
                var data = response.data.data
                ev.orderDetailData = data
            })
        },
        gotIt() {
            if (this.nowShow == true) {
                this.nowShow = false
            }
        },
        changeMail() {
            this.showpass = false;
        },
        login() {
            if (this.fields.username === "") {
                this.$toasted.global.error({
                    message: "Please enter Email",
                });
            } else if (this.fields.password === "") {
                if (this.fields.password === "" && this.showpass === "") {
                    this.$toasted.global.error({
                        message: "Please enter password",
                    });
                }
                this.showpass = true;
            } else {
                var vi = this;
                axios({
                    method: "POST",
                    url: this.$root.URL_ROOT + "api.php",
                    data: this.fields,
                }).then(function(response) {
                    var data = response.data;
                    if (data.status === "success") {
                        localStorage.setItem("user", data.session.uid);
                        localStorage.setItem("token", data.session.uid);
                        vi.nowShow = true
                        vi.$toasted.global.success({
                            message: "Login Success Please wait...",
                        });
                    } else {
                        vi.$toasted.global.error({
                            message: data.msg,
                        });
                    }
                });
            }
        },
        timeSince(date) {

            var seconds = Math.floor((new Date() - date) / 1000);

            var interval = seconds / 31536000;

            if (interval > 1) {
                return Math.floor(interval) + " years";
            }
            interval = seconds / 2592000;
            if (interval > 1) {
                return Math.floor(interval) + " months";
            }
            interval = seconds / 86400;
            if (interval > 1) {
                return Math.floor(interval) + " days";
            }
            interval = seconds / 3600;
            if (interval > 1) {
                return Math.floor(interval) + " hours";
            }
            interval = seconds / 60;
            if (interval > 1) {
                return Math.floor(interval) + " minutes";
            }
            return Math.floor(seconds) + " seconds";
        },
        moreNews() {
            var ip_address = JSON.parse(localStorage.getItem("ip_address"));
            var user_session = localStorage.getItem("user");
            var uid = "";
            if (user_session != null) {
                uid = user_session;
            } else {
                uid = null;
            }
            const axios = require("axios");
            var self = this;
            axios
                .post(this.$root.URL_ROOT + "api.php?type=getAllMoreNews", {
                    uid: uid,
                    ip_address: ip_address,
                })
                .then(function(response) {
                    var data = response.data;
                    if (data.status == "success") {
                        self.OfferProduct = data.news;
                    }
                });
        },
        dontData() {
            var ip_address = JSON.parse(localStorage.getItem("ip_address"));
            var user_session = localStorage.getItem("user");
            var uid = "";
            if (user_session != null) {
                uid = user_session;
            } else {
                uid = null;
            }
            const axios = require("axios");
            var self = this;
            axios
                .post(this.$root.URL_ROOT + "api.php?type=getAllGuidNews", {
                    uid: uid,
                    ip_address: ip_address,
                })
                .then(function(response) {
                    var data = response.data;
                    if (data.status == "success") {
                        self.latestData = data.news;
                    }
                });
        },
        foodData() {
            var ip_address = JSON.parse(localStorage.getItem("ip_address"));
            var user_session = localStorage.getItem("user");
            var uid = "";
            if (user_session != null) {
                uid = user_session;
            } else {
                uid = null;
            }
            const axios = require("axios");
            var self = this;
            axios
                .post(this.$root.URL_ROOT + "api.php?type=getAllFoodNews", {
                    uid: uid,
                    ip_address: ip_address,
                })
                .then(function(response) {
                    var data = response.data;
                    if (data.status == "success") {
                        self.getFoodData = data.news;
                    }
                });
        },
        travelData() {
            var ip_address = JSON.parse(localStorage.getItem("ip_address"));
            var user_session = localStorage.getItem("user");
            var uid = "";
            if (user_session != null) {
                uid = user_session;
            } else {
                uid = null;
            }
            const axios = require("axios");
            var self = this;
            axios
                .post(this.$root.URL_ROOT + "api.php?type=getAllTravelNews", {
                    uid: uid,
                    ip_address: ip_address,
                })
                .then(function(response) {
                    var data = response.data;
                    if (data.status == "success") {
                        self.getTravelData = data.news;
                    }
                });
        },
        guidData() {
            var ip_address = JSON.parse(localStorage.getItem("ip_address"));
            var user_session = localStorage.getItem("user");
            var uid = "";
            if (user_session != null) {
                uid = user_session;
            } else {
                uid = null;
            }
            const axios = require("axios");
            var self = this;
            axios
                .post(this.$root.URL_ROOT + "api.php?type=getAllDontNews", {
                    uid: uid,
                    ip_address: ip_address,
                })
                .then(function(response) {
                    var data = response.data;
                    if (data.status == "success") {
                        self.latestDelay = true;
                        self.DontMiss = data.news;
                    }
                });
        },
        goToTop() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },

        async productDetail() {
            var ev = this;
            ev.showNews=false;
            var ip_address = JSON.parse(localStorage.getItem("ip_address"));
            var user_session = JSON.parse(localStorage.getItem("user"));
            var uid = "";
            if (user_session != null) {
                uid = user_session;
            } else {
                uid = null;
            }
            const response = await axios.post(
                this.$root.URL_ROOT + "api.php?type=getSingleProduct", {
                    id: this.$route.params.id,//ev.product_id,
                    uid: uid,
                    ip_address: ip_address,
                }
            );
            var data = response.data;
           
            ev.detail=[];
            if (data.status == "success") {
                ev.detail = data.product;
                console.log('test data',data.product);
                ev.relatedNews=data.product.related;
                setTimeout(() => {
                    ev.showNews=true;
                }, 1000);
                //ev.showNews=true;


            }
        },
    },
};
</script>
    
<style scoped>
.hpgrid.include-dividers-features>.grid-center:not(.grid-left):before {
    border-left: unset;
}

.swiper {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.social-share {
    display: flex;
    align-items: center;
    color: #787474;
}

.share-me {
    padding: 10px;
}

.share-me>span {
    border: 1px solid #c0c0c0;
    border-radius: 50px;
    margin: 3px 5px;
    padding: 10px;
}

.share-me>span svg {
    fill: #000 !important;
}

.share-me>span svg.fa-icon {
    fill: #000 !important;
}

/* .fa-icon{
        fill: #000 !important;
    } */

.bg-black svg path,
.bg-black svg {
    /* fill: #000 !important;
        stroke: #000 !important; */
    color: #000 !important;
}

.chat-header {
    padding-bottom: 2px;
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 20px;
}

.navbar-header .navbar-brand {
    font-size: 16px;
    color: #000;
    font-weight: bold;
    border-bottom: 1px solid #000;
}

.commment-heading {
    font-size: 18px;
    margin-bottom: 10px;
}

.navbar {
    border-radius: 0;
}

.navbar-header {
    float: none;
    width: 200px;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    height: 50px;
}

.navbar-brand {
    float: none;
    line-height: 50px;
}

.navbar {
    border-radius: 0;
}

.navbar-default {
    background-color: #f8f8f8;
    border-color: #e7e7e7;
}

.navbar {
    position: relative;
    min-height: 50px;
    margin-bottom: 20px;
    border: 1px solid transparent;
}

.navbar-header {
    float: none;
    width: 200px;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    height: 50px;
}

.navbar-default .navbar-brand {
    color: #777;
}

.navbar-brand {
    float: none;
    line-height: 50px;
}

.navbar-brand {
    float: left;
    height: 50px;
    padding: 15px 15px;
    font-size: 18px;
    line-height: 20px;
}

#comment_app {
    margin-top: 30px;
}

.comment-h3 {
    font-size: 18px;
    margin-bottom: 10px;
}

.btn-primaries {
    color: #fff;
    background-color: #0d6efd !important;
    border-color: #0d6efd !important;
}

.mt10 {
    margin-top: 10px;
}

.user-icon {
    color: #0e6efb;
}

.com-likes {
    color: #e10b0b;
}

.comment-head {
    background: #f7f7f7;
    padding: 15px;
}

.pd0 {
    padding: 0px !important;
}

.like-reply {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 250px;
    margin: 10px 0px;
    border: 1px solid #f7f7f7;
}
</style>
    